<template>
  <div id="global-container">
  <Toast />
  <ConfirmDialog :pt="{
    icon: { style: 'font-size: 1.75rem; margin: 10px' },
    header: { style: 'border-radius: 12px 12px 0 0' },
    footer: { style: 'border-radius:  0 0 12px 12px' },
    content: { style: 'direction: rtl' },
    message: { style: 'font-size: 18px' }
  }"></ConfirmDialog>
  <DynamicDialog />
  <div v-show="globalStore.loading">
    <Spinner />
  </div>
  <pull-refresh v-model="refreshing" @refresh="onRefresh" loosingText="" loadingText="" successText="" pullingText="" :pullDistance="pullDistance"
    class="layout-wrapper layout-static">
    <div id="menu-container" v-if="!isLoginRoute()">
      <SideMenu v-if="isMobileMenu()" :key="useAuthRefs.user.value.id" />
      <div v-else>
        <app-topbar></app-topbar>
        <app-sidebar class="layout-sidebar"></app-sidebar>
      </div>
    </div>
    <div id="main-container" :style="paddingTop">
      <ScrollTop :threshold="400" />
      <router-view />
    </div>
  </pull-refresh>
</div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import { useGlobalStore } from '@/stores/global'
import router from '@/router/router'
import ScrollTop from '@/components/ScrollTop.vue'
import Spinner from '@/components/Spinner'
import SideMenu from '@/components/SideMenu.vue'
import PullRefresh from 'pull-refresh-vue3'
import { useMq } from "vue3-mq"
import socketService from '@/service/SocketService'
import { storeToRefs } from 'pinia'
import { useAuthStore } from './stores/auth'
import notificationService from '@/service/NotificationService'
import permissionsHelper from '@/helpers/PermissionsHelper'
import AppTopbar from '@/components/AppTopbar.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import { Capacitor } from '@capacitor/core'

const globalStore = useGlobalStore()
const useAuthRefs = storeToRefs(useAuthStore())
const refreshing = ref(false)
const mq = useMq()
const paddingTop = ref('margin-top: 0px')
const pullDistance = ref(50)

const isMobileMenu = () => {
  return mq.current === 'mobile' || mq.current === 'tablet'
}

const onRefresh = () => {
  globalStore.toggleOn()
  router.go(0)
  setTimeout(() => {
    refreshing.value = false;
  }, 1000);
}

const isLoginRoute = () => {
  return router.currentRoute.value.name === 'login';
}

onBeforeMount(async () => {
  if (Capacitor.getPlatform() === 'ios') {
    paddingTop.value = 'margin-top: 30px'
    pullDistance.value = 100
  }
  await permissionsHelper.handleLocalNotification()
  await router.isReady()
  const currentRoute = router.currentRoute.value.name
  if (currentRoute != 'login') {
    socketService.connect()
    notificationService.loadNotificationsCount()
  }
})

onMounted(() => {
  document.addEventListener('gesturestart', (event) => { event.preventDefault(); }, false)
})

</script>

<style>
@import '/node_modules/primeflex/primeflex.css';

 #app {
  font-family: The-Sans, Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


</style>
